// extracted by mini-css-extract-plugin
module.exports = {"CardCover":"styles_CardCover___JljF","featured":"styles_featured__IAIFs"};